import { render, staticRenderFns } from "./button-group.component.vue?vue&type=template&id=ea87f5de&"
import script from "./button-group.component.vue?vue&type=script&lang=ts&"
export * from "./button-group.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports